export default {
  state: {
    username: '',
    password: '',
    url: '',
    isLoading: false,
  },
};
